import styled from 'styled-components';

export const StyledPipaBalance = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #733200;
  font-family: var(--font-family), Arial;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }

  .img-container {
    height: 14px;
    max-width: 20px;
    margin-right: 2px;
    background-color: transparent;

    &--balance {
      height: 100%;
      object-fit: contain;
    }
  }
`;
